import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { staggerParent, staggerChild } from "@/components/Motion";
import { ArrowRight, Store, User } from "lucide-react";

const CARDS = [
  { to: "/pricing/private", icon: User, who: "Private sellers", big: "Free", sub: "for your first 3 months", then: "Then £9.99 a month for 1 car.", id: "teaser-private", dark: false },
  { to: "/pricing/dealers", icon: Store, who: "Dealerships", big: "£200", sub: "per dealership a month", then: "Unlimited cars. Down to £100 per dealership for larger groups.", id: "teaser-dealers", dark: true },
];

export function PricingTeaser() {
  return (
    <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} className="grid gap-5">
      {CARDS.map((c) => (
        <motion.div key={c.to} variants={staggerChild} whileHover={{ y: -6 }}>
          <Link to={c.to} data-testid={c.id}
            className={`group block rounded-3xl p-7 lg:p-8 border transition-shadow hover:shadow-[0_30px_60px_-30px_rgba(22,36,47,0.45)] ${c.dark ? "bg-navy text-white border-navy" : "bg-white border-navy/10 text-navy"}`}>
            <div className="flex items-center justify-between">
              <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold ${c.dark ? "text-white/60" : "text-slatev"}`}><c.icon className="w-4 h-4" />{c.who}</span>
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </div>
            <div className="mt-4 flex items-baseline gap-2 flex-wrap"><span className="font-heading font-extrabold text-5xl tracking-tighter">{c.big}</span><span className={c.dark ? "text-white/70" : "text-slatev"}>{c.sub}</span></div>
            <p className={`mt-2 text-sm ${c.dark ? "text-white/70" : "text-slatev"}`}>{c.then}</p>
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
}
